<div class="countdown-timer">
  <p>{{ minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }} min</p>
</div>
